import { DragButtonType } from '@data/types';
import classNames from 'classnames';
import React from 'react';
import { hash } from 'utilities/helper';

import DraggableRadialButton from './DraggableRadialButton';

interface Props extends DragButtonType {}

const DragButton: React.FC<Props> = ({
  text,
  questionText = '',
  options,
  showLabels,
  size = 'small',
  type = 'drag',
  ...props
}) => {
  return (
    <>
      <div
        className={classNames(
          'flex flex-col lg:flex-row items-center bg-white rounded-tl-[2rem] rounded-br-[2rem] border border-grey-dark px-2',
          {
            'py-14': size === 'large',
            'pb-12 lg:pb-12 pt-6': size === 'small',
          }
        )}
      >
        {text && (
          <div
            className={classNames(
              'text-sm pt-2 px-4 font-lightNormal lg:w-2/5 lg:mb-0',
              {
                'mb-2': size === 'large',
                'mb-10 mr-auto': size === 'small',
              }
            )}
          >
            {text}
          </div>
        )}
        {options && (
          <div className="relative flex w-full">
            <span className="h-[1px] bg-red absolute top-1/2 -translate-y-1/2 left-0 right-0 block">
              &nbsp;
            </span>
            {options.map((item, index) => (
              <div
                key={hash(item)}
                className="w-1/5 flex justify-center items-center relative"
              >
                {index === 0 && (
                  <>
                    <span className="bg-white w-1/2 absolute top-0 left-0 block">
                      &nbsp;
                    </span>
                    {showLabels === false && (
                      <small className="text-[10px] absolute -bottom-full -left-1/2 -right-1/2 text-center">
                        1 - Poor
                        <span className="absolute w-[1px] bg-grey-dark -top-[100%] bottom-[100%] -translate-y-[25%] left-1/2">
                          &nbsp;
                        </span>
                      </small>
                    )}
                  </>
                )}
                {index === options.length - 1 && (
                  <>
                    <span className="bg-white w-1/2 absolute top-0 right-0 block">
                      &nbsp;
                    </span>
                    {showLabels === false && (
                      <small className="text-[10px] absolute -bottom-full -left-1/2 -right-1/2 text-center">
                        5 - Excellent
                        <span className="absolute w-[1px] bg-grey-dark -top-[100%] bottom-[100%] -translate-y-[25%] left-1/2">
                          &nbsp;
                        </span>
                      </small>
                    )}
                  </>
                )}
                {showLabels && (
                  <span className="absolute w-[1px] bg-grey-dark -bottom-1/2 -translate-y-[25%] left-1/2 hidden md:block">
                    &nbsp;
                  </span>
                )}

                <DraggableRadialButton
                  id={hash([index, questionText, item.value])}
                  question={questionText}
                  value={item.value}
                  className="!border-red bg-white"
                  alternativeStyle={true}
                  size={size}
                  type={type}
                  {...props}
                  answerIndex={index}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      {showLabels && options && (
        <ul className="flex-row text-[10px] lg:text-xs w-full justify-center absolute bottom-4 left-0 right-0 flex px-2">
          {showLabels &&
            options.map((item) => (
              <li
                key={hash(item)}
                className="w-1/5 flex justify-center items-end lg:items-center md:px-4 relative text-center"
              >
                {item.value}
              </li>
            ))}
        </ul>
      )}
    </>
  );
};

export default DragButton;
